import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    CommonFilterModel, CommonPaginatorLaboratoryResourceService,
    CommonPaginatorResourceService,
    CommonParams,
    ExportCommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export class BillingModalEntityGridDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    private readonly _externalFilterModel: CommonFilterModel

    constructor(service: CommonPaginatorResourceService<T>, filterModel: CommonFilterModel) {
        super(service, store.getters.labId)
        this._externalFilterModel = filterModel
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel: CommonFilterModel = { ...filterModel, ...this._externalFilterModel }
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }

    public exporter(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>> {
        const service = this.service as unknown as CommonPaginatorLaboratoryResourceService<T>
        if (!service) {
            throw new Error('undefined service')
        }
        if (!service.export) {
            throw new Error('undefined exporter')
        }
        const filterModel: CommonFilterModel = { ...request.filterModel, ...this._externalFilterModel }
        return service.export(this.laboratoryId, { ...request, filterModel }, params)
    }
}
